/**
 * Contains the logic for our sticky navs
 * 
 * @export
 * @class StickyNav
 */
import { forEach, getParameterByName, toArray } from '../../helpers/utilities';

export class StickyNav {
    private identifier!: string; 
    private blocks!: Element[];
    private links!: HTMLAnchorElement[];
    private activeSection!: string;

    /**
     * @param container  The sticky nav element.
     * @param identifier The URL identifider for the sections
     */
    constructor(container: Element, identifier: string) {
        if(!container || !identifier) return;

        // Set our properties
        this.identifier    = identifier;
        this.activeSection = <string>getParameterByName(identifier);
        this.links         = toArray(container.querySelectorAll('.js-sticky-nav__link'));
        this.blocks        = toArray(document.querySelectorAll('.js-sticky-nav__section'));

        this.bindEvents();
    }


    /**
     * Binds the events that make this work
     */
    private bindEvents(): void {

        // Go to the active section on page load
        const activeElem = this.blocks.filter( (elem: Element) => elem.getAttribute('data-id') === this.activeSection)[0];
        if(activeElem && this.activeSection) {
            setTimeout(() => {
                window.app.modules.global.scroll.animateScroll(activeElem);
            }, 100);
        }


        // Go to section on click
        forEach(this.links, ({}, link: HTMLAnchorElement) => {
            link.addEventListener('click', (event) => {
                const targetID   = getParameterByName(this.identifier, link.href);
                const targetElem = this.blocks.filter( (elem: Element) => elem.getAttribute('data-id') === targetID)[0];

                if(targetElem) {
                    this.toggleLinks(link);
                    window.app.modules.global.scroll.animateScroll(targetElem);
                
                    // Stop link change
                    event.preventDefault();
                }
            });
        });
    }


    /**
     * Toggle the active state for the links
     * 
     * @private
     * @memberof StickyNav
     */
    private toggleLinks(targetLink: HTMLAnchorElement): void {
        forEach(this.links, ({}, link: HTMLAnchorElement) => {
            if(targetLink === link) {
                link.classList.add('c-sticky-side-nav__link--is-active');
            } else {
                link.classList.remove('c-sticky-side-nav__link--is-active');
            }
        });
    }
}
